// extracted by mini-css-extract-plugin
export default {"shoppingBagQty":"BottomNavBar_shoppingBagQty__t1IFc"};